export default __webpack_public_path__ + "static/media/SB_Rectangle4.015aa97e.svg";